import classNames from 'clsx';
import React, { createRef, PureComponent, ReactElement } from 'react';
import { IS_BIZ_USER } from 'reactApp/appHelpers/configHelpers';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import { snackbarController } from 'reactApp/modules/snackbar/snackbar.controller';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { Button } from 'reactApp/ui/Button/Button';
import { ShadeRight } from 'reactApp/ui/ShadeRight/ShadeRight';
import { CopyIcon, LinkIcon } from 'reactApp/ui/VKUIIcons';
import { copy as copyApiCall } from 'reactApp/utils/copyToClipboard';
import { noop } from 'reactApp/utils/helpers';

import styles from './CopyWeblink.css';

interface CopyProps {
    onCopy: (props?: any) => any;
    onClick?: (props?: any) => any;
    publicUrl?: string;
    autoCopy?: boolean;
    theme?: 'folder' | 'publish';
    type?: 'link' | 'new';
    isPhone?: boolean;
}

export class CopyWeblink extends PureComponent<CopyProps> {
    public static defaultProps = {
        onCopy: noop,
        onClick: noop,
    };

    private input = createRef<HTMLInputElement>();

    public componentDidMount(): void {
        const { publicUrl, autoCopy } = this.props;

        if (!!publicUrl && autoCopy && !IS_BIZ_USER) {
            this.copy(this.input);
        }
    }

    private copy = (input): void => {
        const { onCopy, isPhone } = this.props;

        if (!input || !input.current) {
            return;
        }

        if (isPhone) {
            toolbarActions.shareLink({ url: input.current.value });
            return;
        }

        const processCopy = (notification): void => {
            if (notification) {
                snackbarController.showSnackbar(notification);
            }

            if (input.current) {
                input.current.select();
                input.current.setSelectionRange(0, input.current.value.length);
            }

            onCopy(notification?.type === 'success');
        };

        copyApiCall(input.current.value)
            .then((resp): void => {
                const hasBeenCopied = resp ? resp.hasBeenCopied : true;
                return processCopy(
                    hasBeenCopied
                        ? {
                              type: SnackbarTypes.success,
                              text: 'Ссылка успешно скопирована',
                              id: 'copyLink',
                              closable: true,
                          }
                        : null
                );
            })
            .catch((): void =>
                processCopy({ type: SnackbarTypes.failure, text: 'Не удалось скопировать ссылку', id: 'copyLink', closable: true })
            );
    };

    handleCopy = (e) => {
        e.stopPropagation();

        this.copy(this.input);
    };

    handleClick = () => {
        this.props?.onClick?.();
    };

    handleInputClick = () => {
        if (!this.input?.current) {
            return;
        }
        this.input.current.select();
        this.input.current.setSelectionRange(0, this.input.current.value.length);
    };

    handleCm = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    public render(): ReactElement {
        const { publicUrl, theme, type = 'link', isPhone } = this.props;

        if (type === 'new') {
            return (
                <div
                    className={classNames({
                        [styles[`root_type_${type}`]]: type,
                        [styles.root_phone]: isPhone,
                    })}
                    onContextMenu={this.handleCm}
                >
                    <input value={publicUrl} className={styles.input} ref={this.input} readOnly onClick={this.handleInputClick} />

                    <Button theme={isPhone ? 'vk' : 'octavius'} primary middle onClick={this.handleCopy}>
                        {isPhone ? 'Поделиться' : 'Скопировать'}
                    </Button>
                </div>
            );
        }

        return (
            <div className={classNames({ [styles.controls]: true, [styles[`controls_${theme}`]]: !!theme })} onContextMenu={this.handleCm}>
                <div className={styles.link}>
                    <LinkIcon />
                </div>
                <ShadeRight theme={theme}>
                    <input
                        value={publicUrl}
                        className={styles.input}
                        ref={this.input}
                        title="Скопировать"
                        onClick={this.handleCopy}
                        readOnly
                    />
                </ShadeRight>
                <div className={styles.copy} title="Копировать ссылку" onClick={this.handleClick}>
                    <CopyIcon data-qa-name="copy-link-icon" onClick={this.handleCopy} />
                </div>
            </div>
        );
    }
}
